import React, { Suspense } from 'react'
import { Layout } from '@douyinfe/semi-ui'
import Header from './components/header'
import Sider from './components/sider'
import Footer from './components/footer'
import { Outlet } from 'react-router-dom'
import SuspendFallbackLoading from '@src/components/fallback-loading'
import ThemeSettings from '@src/components/ThemeSettings'
import GlobalWatermark from '@src/components/GlobalWatermark'
import GlobalSearch from '@src/components/GlobalSearch'
import ErrorBoundary from '@src/components/ErrorBoundary'

import './index.scss'

const { Content } = Layout

const Index: React.FC = () => {
	return (
		<>
			<Layout className="layout-page">
				<Sider />
				<Layout>
					<Header />
					<div className="layout-content-wrap">
						<Content className="layout-content">
							{/* 错误边界：包住 Outlet 让 page 报错不会拖垮整个 Layout（Sider/Header/Footer 不变） */}
							<ErrorBoundary scope="页面">
								<Suspense fallback={<SuspendFallbackLoading message="正在加载中" />}>
									<Outlet />
								</Suspense>
							</ErrorBoundary>
						</Content>
					</div>
					<Footer />
				</Layout>
			</Layout>
			<ThemeSettings />
			<GlobalWatermark />
			<GlobalSearch />
		</>
	)
}

export default Index
